import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_128: FaireProductEntity = {
  token: "legacy_prod_abbott-128",
  type: "product",
  name: "Bell Shaped Cloche-6 H",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/9dab5341d49974bf9e4e2d249aa401025b83be6f19552829e8bed3414a4dffcc.jpeg",
  priceDollars: 32,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
